module.exports = __webpack_public_path__ + "assets/icon-arrow-down-alt.98b6d3e5.png";